module.exports = __webpack_public_path__ + "img/betty.2cc53aa.webp";